'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var dataKey = exports.dataKey = 'text';


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-form/lib/util/eventConsts.js
 ** module id = 3715
 ** module chunks = 0
 **/